/* eslint-disable */
import request from '@/utils/request';

export function getAnalizeByPosition(data) {
    return request({
        url: process.env.VUE_APP_API_BACKEND + 'analize/Valves/LinesAndPointsByPosition',
        method: 'post',
        data: data
    }) as any
}